import {
  Maybe,
  B2BPaymentMethod,
  PaymentMethodState,
  PaymentMethodStripeSepa,
} from "@oysterhr/schema"
import { Alert, Link } from "@oysterhr/ui"
import { useTranslation } from "react-i18next"

interface AuthorizationAlertProps {
  paymentMethod?: Maybe<B2BPaymentMethod>
  onAuthorize: (paymentMethod: PaymentMethodStripeSepa | B2BPaymentMethod) => void
}

export const AuthorizationAlert = ({ paymentMethod, onAuthorize }: AuthorizationAlertProps) => {
  const { t } = useTranslation("company_interface/CompanyPaymentMethodsPage/SepaFlow", {
    keyPrefix: "alerts",
  })

  if (!paymentMethod || paymentMethod.state !== PaymentMethodState.Initialized) return null

  const handleAuthorize = () => {
    if (paymentMethod) {
      onAuthorize(paymentMethod)
    }
  }

  return (
    <Alert variation="warning">
      <Alert.Icon />
      <Alert.Content className="flex space-x-1">
        <div>{t("authorize.content")}</div>
        <div>
          <Link as="button" onClick={handleAuthorize}>
            {t("authorize.action")}
          </Link>
        </div>
      </Alert.Content>
    </Alert>
  )
}
